import type React from 'react';

import { usePromoteCtaDisplayed } from '#src/app/pages/petitionDetails/shared/hooks';

import { SideSignedNonPromotable } from './SideSignedNonPromotable';
import { SideSignedPromotable } from './SideSignedPromotable';

export const SideSigned: React.FC<EmptyProps> = () => {
	const ctaDisplayed = usePromoteCtaDisplayed();

	return ctaDisplayed ? <SideSignedPromotable /> : <SideSignedNonPromotable />;
};
